export const TODOLIST_GRID_LABELS = 
{
    scanId: 'Scan #',
    onHold: 'On Hold',
    fileName: 'File Name',
    CS2Id: 'CS2 #',
    AdvId: 'A+ Reference Number',
    policyNumber: 'Policy #',
    docDescription: 'Document Description',
    fromUser: 'From User',
    fromFolder: 'From Folder',
    redirectReason: 'Redirect Reason',
    dateRedirected: 'Date Redirected',
    dateInitiated: 'Date Initiated',
    dateAvailable: 'Date Available',
    deletedBy : 'Deleted By',
    dateDeleted: 'Date Deleted',
    dateExpired: 'Date Expired'

}
export const INDEXING_GRID_LABELS = {
    cs2RefNum: 'CS2 #',
    advRefNum: 'A+ Ref #',
    status: 'STATUS',
    fullName: 'FULL NAME'
}

export const CUSTOMER_STATUS = {
    active: 'Active',
    inactive: 'In Active',
}
export const SEARCH_RADIO_LABELS = {
    advRefNum: 'A+ Reference #',
    cs2RefNum: 'CS2 #',
    polRefNum: 'CS2 Policy #'
}
export const SEARCH_RADIO_Values = {
    advRefNum: '101',
    cs2RefNum: '100',
    polRefNum: '100'
}
export const INDEXING_PROCESSING_LABELS = {
    documentType: 'Document Type',
    term: 'Term',
    policy: 'Policy',
    folder: 'Folder',
}
export const REFI_PROCESSING_LABELS = {
    reiPanel: 'Request of Evidence of Insurance',
    customerPanel: 'Customer Information',
    mortgageePanel: 'Mortgagee Information',
    requestorPanel: 'Requestor Information',
    requestType: 'Request Type',
    requestRCE: 'Request RCE',
    vesting: 'Vesting',
    policyNumber: 'Policy Number',
    carrier: 'CarrierName',
    firstName: 'First Name/Company Name',
    lastName: 'Last Name',
    middleName: 'Middle Name',
    companyName: 'Company Name',
    propAddress: 'Property Address Line 1',
    city: 'City',
    state: 'State',
    zip: 'ZipCode',
    loanNumber: 'Loan Number',
    loanPosition: 'Loan Position',
    impounds: 'Impounds',
    mortagageeName: 'Mortgagee Name',
    mortgageeClause: 'Mortgagee Clause',
    mortgageeAddress: 'Mortgagee Address Line 1',
    requestorName: 'Requestor Name',
    email: 'Email',
    addressLine2: 'Address Line 2',
    business: 'Business'
}
export const INDEXING_IMAGING_TASK_LABELS = {
   redirect_to_group: 'Redirect To',
   folder: 'Folder',
   person: 'Person',
   redirect_reason: 'Redirect Reason',
   redirect_note: 'Redirect Note',
   policy_term: 'POLICY AND TERM',
   One_Step: 'One Step'
}

export const DOCUMATE_INDEXING_BUTTONS = {
    search: 'SEARCH',
    reset: 'RESET',
    delete: 'DELETE',
    close: 'CLOSE',
    placeOnHold: 'PLACE ON HOLD',
    index: 'INDEX',
    submit: 'SUBMIT',
    update: 'UPDATE',
    indexAndNext: 'INDEX & NEXT',
    indexAndEndAutoprocessing: 'INDEX & END',
    skip: 'SKIP',
};
export const DOCUMATE_LABEL='DocuMate+'
export const DOCUMATE_SCAN='Scan'
export const DOCUMATE_SEARCH='Search'
export const DOCUMATE_ADMIN_DOCUMENT='Admin Documents'
export const DOCUMATE_REFI='Refi Process'
export const DOCUMATE_SCAN_TITLE='DocuMate+ Images'
export const DOCUMATE_INDEXING_TITLE='DocuMate+ Indexing'
export const DOCUMATE_REFI_TITLE='DocuMate+ Refinance Automated Process'
export const DOCUMATE_INDEXING='Indexing & Processing'
export const DOCUMATE_RECYCLE_BIN='Recycle Bin'
export const DOCUMATE_RECYCLE_BIN_PROCESSING='Recycle Bin Processing'
export const DOCUMATE_RECYCLE_BIN_RESTORE='Restore'
export const DOCUMATE_RECYCLE_BIN_CLOSE='Close'
export const DOCUMATE_UNASSIGNED='Unassigned'
export const DOCUMATE_DEST_FOLDER='Destination Folders'
export const CONFIRM='Confirm'
export const CONFIRM_YES='Yes'
export const CONFIRM_NO='No'
export const CONFIRM_OK='Ok'
export const TODO_LIST_GROUPS='Group'
export const TODO_LIST_FOLDERS='ToDo Folder'
export const TODO_LIST_USERS='User(s)'
export const TODO_LIST_DELETED_BY= 'Deleted By'
export const APPROVE_DOCUMENT='APPROVE'
export const REJECT_DOCUMENT='REJECT'
export const CLOSE_DOCUMENT='CLOSE'
export const CLOSE_NEXT_DOCUMENT='CLOSE & NEXT'
export const CLOSE_END_AUTOPROCESS='CLOSE & END AUTOPROCESSING'
export const DOCUMATE_ADMIN_DOCUMENT_TITLE='Admin Documents'
export const TODO_LIST_ON_HOLD='On Hold — not available for autoprocessing'

// DocViewer Pagination Labels
export const DOC_VIEWER_FIRST_PAGE='<<'
export const DOC_VIEWER_LAST_PAGE='>>'
export const DOC_VIEWER_GO_TO_PAGE='Go to page:'
export const DOC_VIEWER_FIRST_PAGE_TITLE='First Page'
export const DOC_VIEWER_LAST_PAGE_TITLE='Last Page'
export const DOC_VIEWER_PREVIOUS_PAGE_TITLE='Previous Page'
export const DOC_VIEWER_NEXT_PAGE_TITLE='Next Page'
export const DOC_VIEWER_GO_TO_PAGE_TITLE='Enter page number'